import { animationIcons } from '../../../utils/imagePath';

export const ANIMATION_EFFECTS = [
  { id: 'playModel', name: 'Play Model', icon: animationIcons?.Ani9 },
  { id: 'move', name: 'Move', icon: animationIcons?.Ani1 },
  { id: 'rotate', name: 'Rotate', icon: animationIcons?.Ani3 },
  { id: 'scale', name: 'Scale', icon: animationIcons?.Ani6 },
  { id: 'bounce', name: 'Bounce', icon: animationIcons?.Ani7 },
  // { id: 'shake', name: 'Shake', icon: animationIcons?.animationShake },
  // { id: 'pulse', name: 'Pulse', icon: animationIcons?.animationPulse },
  // { id: 'fade', name: 'Fade', icon: animationIcons?.Ani7 },
  { id: 'fadein', name: 'Fade In', icon: animationIcons?.animationFadeIn },
  { id: 'fadeout', name: 'Fade Out', icon: animationIcons?.animationFadeOut },
  // { id: 'orbit', name: 'Orbit', icon: animationIcons?.animationOrbit },
  // { id: 'wiggle', name: 'Wiggle', icon: animationIcons?.animationWiggle },
  // { id: 'spring', name: 'Spring', icon: animationIcons?.Ani7 },
  // Legacy support
];

export const EASING_OPTIONS = ['None', 'Ease-in', 'Ease-out', 'In-out'];

export const DEFAULT_ANIMATION_SETTINGS = {
  duration: 3.0,
  startTime: 0.0,
  easing: 'None',
  activeAxes: { x: true, y: false, z: true },
  startPosition: { x: 1, y: 0, z: 0 },
  endPosition: { x: 10, y: 0, z: 0 },
  loop: false,
  // Enhanced move effect defaults
  movementType: 'linear',
  circleCenter: { x: 0, y: 0, z: 0 },
  circleRadius: 5,
  circleAxis: 'z',
  circleDirection: 'clockwise',
  circleStartAngle: 0,
  circleEndAngle: 360,
  circleRevolutions: 1,
  bezierControl1: { x: 5, y: 5, z: 0 },
  bezierControl2: { x: 10, y: -5, z: 0 },
  sineAmplitude: { x: 2, y: 0, z: 0 },
  sineFrequency: 1,
  sinePhase: 0,
  sineAxis: 'x',
  figure8Radius: 5,
  figure8Axis: 'z',
  figure8Speed: 0.5,
  spiralRadius: 5,
  spiralHeight: 5,
  spiralTurns: 2,
  spiralAxis: 'z',
  spiralDirection: 'up',
  relativeToObject: false,
  followPath: false,
  pathSmoothing: 0.5,
  autoRotate: false,
  lookAtTarget: { x: 0, y: 0, z: 0 },
  // Rotate effect defaults
  startRotation: { x: 0, y: 0, z: 0 },
  endRotation: { x: 0, y: 0, z: 360 },
  rotationAxis: { x: false, y: false, z: true },
  rotationAmount: 360,
  rotationSpeed: 1,
  rotationDirection: 'clockwise',
  pivotPoint: { x: 0, y: 0, z: 0 },

  // // Fade effect defaults
  // startOpacity: 1,
  // endOpacity: 0,
  // fadeType: 'fadeOut',
  // fadeSpeed: 1,

  fadeType: 'fadeOut', // 'fadeIn' | 'fadeOut'
  fadeSpeed: 1,

  // Fade In defaults
  fadeIn: {
    startOpacity: 0,
    endOpacity: 1,
  },

  // Fade Out defaults
  fadeOut: {
    startOpacity: 1,
    endOpacity: 0,
  },
  // Bounce effect defaults
  bounceHeight: 5,
  bounceCount: 3,
  bounceDecay: 0.8,
  bounceAxis: 'y',
};

export const TIMELINE_CONFIG = {
  DEFAULT_HEIGHT: 240,
  MIN_HEIGHT: 40,
  MAX_HEIGHT: 240,
  DEFAULT_SCALE: 1,
  MIN_SCALE: 0.1,
  MAX_SCALE: 10,
  DEFAULT_DURATION: 7,
  MIN_DURATION: 1,
  ROW_HEIGHT: 28,
  MAX_ROWS: 20,
};

export const PLAYBACK_CONFIG = {
  DEFAULT_FPS: 60,
  MIN_DURATION: 0.1,
};
